var path = 'app/scripts/modules/appengine/pipeline/stages/startServerGroup/startServerGroupStepLabel.html';
var html = "<span class=\"task-label\">\n  Start Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/appengine/pipeline/stages/startServerGroup/startServerGroupStepLabel.html
// module id = 1262
// module chunks = 0